import { pb } from './pocketbase';
import eventEmitter from './event.service';

export const getCommercials = async () => {
  try {
    const result = await pb.collection('users').getList(1, 50, {
      filter: `role ~ "Commercial"`,
      sort: 'name'
    });
    return result.items;
  } catch (error) {
    console.error('Erreur lors de la récupération des commerciaux:', error);
    return [];
  }
};

export const getProspectList = async (options = {}) => {
  try {
    const {
      page = 1,
      perPage = 30,
      sort = '-created',
      filter = '',
      expand = 'desired_formations,assigned_to',
      fullData = true
    } = options;
    
    const pbOptions = {
      sort,
      filter,
      expand
    };
    
    if (!fullData) {
      pbOptions.fields = options.fields || 'id,first_name,last_name,email,phone,status,last_contact_at,desired_formations,expand.assigned_to';
    }
    
    const result = await pb.collection('prospects_student').getList(page, perPage, pbOptions);
    
    return result;
  } catch (error) {
    console.error('Erreur lors de la récupération des prospects:', error);
    throw error;
  }
};

export const getProspectById = async (id, options = {}) => {
  try {
    const defaultOptions = {
      expand: 'desired_formations,assigned_to'
    };
    
    const mergedOptions = { ...defaultOptions, ...options };
    
    const record = await pb.collection('prospects_student').getOne(id, mergedOptions);
    return record;
  } catch (error) {
    console.error(`Erreur lors de la récupération du prospect avec l'ID ${id}:`, error);
    throw error;
  }
};

export const createProspect = async (dataProspect) => {
  try {
    if (pb.authStore.isValid && pb.authStore.model) {
        const prospectWithPartnerId = {
            ...dataProspect,
            partner_id: pb.authStore.record.partner_id
        };
        const record = await pb.collection('prospects_student').create(prospectWithPartnerId);        
        eventEmitter.dispatch('prospectsUpdated');
        return record;
    } else {
        console.error('Aucun utilisateur authentifié. Impossible de créer le prospect sans partner_id.');
        return null;
    }
  } catch (error) {
    console.error('Erreur lors de la création du prospect:', error);
    throw error;
  }
};

export const searchProspects = async (query) => {
  try {
    const filter = `first_name ~ "${query}" || last_name ~ "${query}" || email ~ "${query}" || phone ~ "${query}"`;
    const result = await pb.collection('prospects_student').getList(1, 20, {
      filter,
      expand: 'desired_formations',
      sort: 'first_name'
    });
    return result.items;
  } catch (error) {
    console.error('Erreur lors de la recherche des prospects:', error);
    return [];
  }
};

export const assignCommercialToProspect = async (prospectId, commercialId) => {
  try {
    const record = await pb.collection('prospects_student').update(prospectId, { assigned_to: commercialId });
    eventEmitter.dispatch('prospectsUpdated');
    return record;
  } catch (error) {
    console.error('Failed to assign commercial to prospect:', error);
    throw error;
  }
};

export const updateProspect = async (id, data) => {
  try {
    const record = await pb.collection('prospects_student').update(id, data);      
    return record;
  } catch (error) {
    console.error(`Erreur lors de la mise à jour du prospect avec l'ID ${id}:`, error);
    throw error;
  }
};

export const deleteProspect = async (id) => {
  try {
    await pb.collection('prospects_student').delete(id);
    return true;
  } catch (error) {
    console.error(`Erreur lors de la suppression du prospect avec l'ID ${id}:`, error);
    throw error;
  }
};

export const getUnassignedProspectsCount = async () => {
    try {
        const records = await pb.collection('prospects_student').getFullList({
            filter: "assigned_to = null",
        });
        return records.length;
    } catch (error) {
        throw error;
    }
};

export const updateProspectFileStatus = async (prospectId, fileStatus) => {
  try {
      if (!prospectId) {
          throw new Error('ID prospect non fourni');
      }
      
      // Valider le statut de fichier
      if (!['Complet', 'Incomplet'].includes(fileStatus)) {
          throw new Error('Statut de fichier invalide. Utilisez "Complet" ou "Incomplet"');
      }
            
      // Mettre à jour uniquement le statut du dossier sans modifier les autres champs
      const updatedProspect = await pb.collection('prospects_student').update(prospectId, {
          file_status: fileStatus
      });
      
      // Retourner le prospect mis à jour avec toutes ses informations
      return updatedProspect;
  } catch (error) {
      console.error('Erreur lors de la mise à jour du statut de dossier:', error);
      throw error;
  }
};


